var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 12.6666C10.1296 12.6666 12.6667 10.1295 12.6667 6.99992C12.6667 3.87032 10.1296 1.33325 7.00004 1.33325C3.87044 1.33325 1.33337 3.87032 1.33337 6.99992C1.33337 10.1295 3.87044 12.6666 7.00004 12.6666Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99992 0.333252C3.31803 0.333252 0.333252 3.31803 0.333252 6.99992C0.333252 10.6818 3.31803 13.6666 6.99992 13.6666C8.48014 13.6666 9.84769 13.1842 10.9539 12.368L13.1953 14.6094C13.5858 14.9999 14.219 14.9999 14.6095 14.6094C15 14.2188 15 13.5857 14.6095 13.1951L12.3681 10.9537C13.1842 9.84754 13.6666 8.48006 13.6666 6.99992C13.6666 3.31803 10.6818 0.333252 6.99992 0.333252ZM2.33325 6.99992C2.33325 4.4226 4.4226 2.33325 6.99992 2.33325C9.57723 2.33325 11.6666 4.4226 11.6666 6.99992C11.6666 9.57723 9.57723 11.6666 6.99992 11.6666C4.4226 11.6666 2.33325 9.57723 2.33325 6.99992Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40727 4.07393C5.06972 3.41148 5.98776 3 6.99998 3C8.01223 3 8.93027 3.41148 9.59272 4.07393C9.98324 4.46445 9.98324 5.09762 9.59272 5.48814C9.2022 5.87866 8.56903 5.87866 8.17851 5.48814C7.87582 5.18545 7.46053 5 6.99998 5C6.53947 5 6.12418 5.18545 5.82149 5.48814C5.43096 5.87866 4.7978 5.87866 4.40727 5.48814C4.01675 5.09762 4.01675 4.46445 4.40727 4.07393Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDark);
export default __webpack_public_path__ + "static/media/search_dark.fdf46f769c3ecbdae19049ecab808b14.svg";
export { ForwardRef as ReactComponent };